import type { HeadersFunction, LoaderFunction, MetaFunction } from '@remix-run/node';
import { useRouteLoaderData } from '@remix-run/react';

import PrivatePublication from '~/components/PrivatePublication';
import StaticPage from '~/components/StaticPage';
import { staticPageClientLoader } from '~/components/StaticPage/staticPageClientLoader';
import useTypedLoaderData from '~/hooks/useUtils/useTypedLoaderData';
import type { RootLoaderData } from '~/root';
import getStaticPageMetaData from '~/utils/getStaticPageMetaData';
import { shouldRevalidateLoaderData } from '~/utils/shouldRevalidateLoaderData';

import type { StaticPageLoaderData } from '../services/static_page';
import { staticPageLoader } from '../services/static_page';

export const headers: HeadersFunction = ({ loaderHeaders }) => {
  return {
    'cache-control': loaderHeaders.get('cache-control') || 'max-age=0', // no-cache
    'Cache-Tag': 'orchid-page',
  };
};

export const meta: MetaFunction<typeof staticPageLoader> = getStaticPageMetaData;
export const loader: LoaderFunction = async ({ request }) => {
  return staticPageLoader({
    request,
    pageRequestParams: {
      pathname: 'home',
    },
  });
};

export const clientLoader = staticPageClientLoader;

const Home = () => {
  const { page, site } = useTypedLoaderData<StaticPageLoaderData>();
  const { isLoggedIn, isStagingPreview } = useRouteLoaderData('root') as RootLoaderData;

  if ((site.publication.private || site.publication.require_subscriber_approval) && !isLoggedIn && !isStagingPreview) {
    return <PrivatePublication publication={site.publication} site={site} />;
  }

  return <StaticPage page={page} site={site} />;
};

export const shouldRevalidate = shouldRevalidateLoaderData;

export default Home;
